
/**
 * \@docs-private
 * @return {?}
 */
export function getMdInputContainerPlaceholderConflictError(): Error {
  return Error('Placeholder attribute and child element were both specified.');
}
/**
 * \@docs-private
 * @param {?} type
 * @return {?}
 */
export function getMdInputContainerUnsupportedTypeError(type: string): Error {
  return Error(`Input type "${type}" isn't supported by md-input-container.`);
}
/**
 * \@docs-private
 * @param {?} align
 * @return {?}
 */
export function getMdInputContainerDuplicatedHintError(align: string): Error {
  return Error(`A hint was already declared for 'align="${align}"'.`);
}
/**
 * \@docs-private
 * @return {?}
 */
export function getMdInputContainerMissingMdInputError(): Error {
  return Error('md-input-container must contain an mdInput directive. ' +
                   'Did you forget to add mdInput to the native input or textarea element?');
}
